import { registerLicense } from '@syncfusion/ej2-base';

export function loadSyncfusionLicense() {
    registerLicense(
        'ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5XdE1jXn9bcnBSRWhaWkdx'
    );
}

// Registering Syncfusion license key
loadSyncfusionLicense();
